export const environment = {
  "PRIVATE_LOADBOARD_USERS": [
    "encloseddispatcher@gmail.com",
    "aleksander@ritewaytransport.com"
  ],
  "apiIdLogRocket": "61w5ga/operations-portal",
  "apiIdLogRocketUat": "",
  "apiUrl": "https://api-operator.loadgenie.com/",
  "domainLoginPortal": "https://loadgenie.com/",
  "geocodeApiKey": "AIzaSyDIaLSGfnT6Ks7c-XdYtNq0oIZo2pbj7Vw",
  "geocodeUrl": "https://maps.googleapis.com/maps/api/geocode/json",
  "heremapsApiKey": "dx3BpBYtI6nZJi3Tz-A1CecsIWM460oHowEn9_ohLJQ",
  "heremapsUrl": "https://geocode.search.hereapi.com/v1/geocode",
  "instance": "pdn",
  "mercuryAuthorizeApiLoginID": "9qh544MLeLB",
  "mercuryAuthorizeClientKey": "7hnPQFpmFTLQ9E78ybCpQt9x68VNLnA369f7QEFcrj76e3bzeY6m7RGTHC7VeMen",
  "production": true,
  "resourcesUrl": "https://riteway-customerportal-static.s3.amazonaws.com/uploads/",
  "ritewayAuthorizeApiLoginID": "6YTtYeu459DK",
  "ritewayAuthorizeClientKey": "9r4mZ7eVT57t4e5ejDL7BeLpGhsu2d35TBvHTTWHRR6PTd89ywDk8LsB3yWk8ybc",
  "socketUrl": "https://sockets.loadgenie.com",
  "tokenSocket": "",
  "usersWithSuperDashboardAccess": [
    848,
    284300,
    1004,
    202520,
    264635,
    9527
  ]
}
